import * as favoritesActions from './actions';
import favoritesEpics from './epics';
import reducer from './reducers';
import * as favoritesSelectors from './selectors';
import * as favoritesTypes from './types';

export { favoritesActions, favoritesEpics, favoritesSelectors, favoritesTypes };

export default reducer;
